import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import {callTargetedAction} from 'client/framework';
import Tooltip from 'sg/Tooltip/Tooltip.react';
import tooltipActions from 'sg/Tooltip/Tooltip.actions';
import classnames from 'classnames';
import './sg-word-tooltip.scss';

export default class WordTooltip extends React.Component {
  static propTypes = {
    term: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.node]).isRequired,
    className: PropTypes.string,
    color: PropTypes.oneOf(['light', 'dark']),
    content: PropTypes.node.isRequired,
    onHover: PropTypes.bool,
    position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    storeName: PropTypes.string
  };

  static defaultProps = {
    onHover: false
  };

  constructor(props) {
    super(props);
    this.storeName = props.storeName || `WordTooltipStore${uuid()}`;
  }

  toggleDropdown = () => {
    callTargetedAction({
      name: tooltipActions.TOGGLE_VISIBILITY,
      targetStore: this.storeName
    });
  };

  noop = () => {};

  render() {
    const wrapperClass = classnames('sg-word-tooltip', this.props.className);
    return (
      <dl className={wrapperClass}>
        <dt
          className='sg-word-tooltip__term'
          onClick={!this.props.onHover ? this.toggleDropdown : this.noop}
          onMouseEnter={this.props.onHover ? this.toggleDropdown : this.noop}
          onMouseLeave={this.props.onHover ? this.toggleDropdown : this.noop}
        >
          {this.props.term}
        </dt>
        <dd className='sg-word-tooltip__definition'>
          <Tooltip
            color={this.props.color}
            position={this.props.position}
            storeName={this.storeName}
            toggleOnHover={this.props.onHover}
          >
            {this.props.content}
          </Tooltip>
        </dd>
      </dl>
    );
  }
}
